import { MenuGroup } from "@portal/BaseComponents/Menu/type";
import { GenericRadioOptions } from "@portal/BaseComponents/Radio/types";
import { DisputeViews } from "@portal/types/entities/dispute";
import { DefaultDisputeKeys } from "./type";

const customerFilterGroups: MenuGroup[] = [
  {
    type: "group",
    label: "Customer",
    key: "Customer",
    children: [],
  },
];
const InvoiceFilterGroups: MenuGroup[] = [
  {
    type: "group",
    label: "Invoice",
    key: "Invoice",
    children: [],
  },
];

export const disputeFilterGroups = [
  ...customerFilterGroups,
  ...InvoiceFilterGroups,
];

export const defaultDisputeKeys: DefaultDisputeKeys[] = [
  "date_range",
  "dispute_type_ids",
  'from_amount',
  "from_date",
];
export const disputeViewOptions: GenericRadioOptions<DisputeViews> = [
  {
    label: "All",
    value: "ALL",
  },
  { label: "Open", value: "OPEN" },
  {
    label: "Closed",
    value: "CLOSED",
  },
  {
    label: "Waiting on Customer",
    value: "WAITING_ON_CUSTOMER",
  },
];

export const disputeStatusOptions = [
  { label: "Open", value: "OPEN" },
  {
    label: "Closed",
    value: "CLOSED",
  },
  {
    label: "Waiting on Customer",
    value: "WAITING_ON_CUSTOMER",
  },
];
